import React from 'react';
import { BrowserRouter as Router, Route, Routes, NavLink } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import CreateQuotePage from './pages/CreateQuotePage';
import SavedPage from './pages/SavedPage';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';
import { inject } from '@vercel/analytics';

// Silently ignore failures — ad blockers or missing Vercel Analytics
// setup should never crash the app.
try { inject(); } catch {}

function App() {
    return (
        <HelmetProvider>
        <Router>
            <div className="App">
                <nav>
                    <span className="brand">
                        Captions<span className="brand-dot">.</span>
                    </span>
                    <div className="nav-right">
                    <ul>
                        <li>
                            <NavLink
                                to="/"
                                end
                                className={({ isActive }) => isActive ? 'active' : ''}
                            >
                                Discover
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/create-quote"
                                className={({ isActive }) => isActive ? 'active' : ''}
                            >
                                Create
                            </NavLink>
                        </li>
                        <li>
                            <NavLink
                                to="/saved"
                                className={({ isActive }) => isActive ? 'active' : ''}
                            >
                                Saved
                            </NavLink>
                        </li>
                    </ul>
                    {/* Replace YOUR_BMC_USERNAME with your buymeacoffee.com username */}
                    <a
                        href="https://buymeacoffee.com/YOUR_BMC_USERNAME"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bmc-link"
                    >
                        ☕ Support
                    </a>
                    </div>
                </nav>
                <ErrorBoundary>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/create-quote" element={<CreateQuotePage />} />
                        <Route path="/saved" element={<SavedPage />} />
                    </Routes>
                </ErrorBoundary>
            </div>
        </Router>
        </HelmetProvider>
    );
}

export default App;
